import { ListItemResponse } from "@/web-client/api";
import EditListItemContext from "@/contexts/EditListItemContext";
import { FC, PropsWithChildren, useCallback, useContext, useMemo } from "react";

type Props = {
  listItem: ListItemResponse;
};

const EditableListChildItemWrapper: FC<PropsWithChildren<Props>> = ({
  children,
  listItem,
}): JSX.Element => {
  const { isEditing, selectHandler, isSelectedItem } =
    useContext(EditListItemContext);

  const isSelected = useMemo(() => {
    return isSelectedItem(listItem);
  }, [isSelectedItem, listItem]);

  const clickHandler = useCallback(() => {
    selectHandler({ selected: !isSelected, item: listItem });
  }, [selectHandler, listItem, isSelected]);

  if (!isEditing) return <>{children}</>;

  return (
    <button
      className={[
        "p-12 rounded-md hover:bg-gray-200",
        isSelected ? "bg-gray-200 " : "",
      ].join(" ")}
      onClick={clickHandler}
    >
      <div className="pointer-events-none">{children}</div>
    </button>
  );
};
export default EditableListChildItemWrapper;
